import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';

import { map } from 'rxjs';

import { TranslationScope } from './models/translation-scope.type';
import { TranslationStore } from './state/translation.store';

export const translationGuard = (...scopes: TranslationScope[]): CanActivateFn => () => {
  const translationStore = inject(TranslationStore);
  return translationStore.loadTranslations(...scopes).pipe(map(() => true));
}
